module.exports = __webpack_public_path__ + "static/media/img-dentist-thumb@3x.72781d93.png";